import { launchWhenVisible } from './rainbokeh-core.js';
import * as anims from './rainbokeh-animations.js';
import { launchBgBokeh } from './rainbokeh-bokeh.js';

const MAKERS = {
  ocean:     anims.makeOcean,
  waveform:  anims.makeWaveform,
  pixels:    anims.makePixels,
  network:   anims.makeNetwork,
  prism:     anims.makePrism,
  terminal:  anims.makeTerminal,
  circuit:   anims.makeCircuit,
  agents:    anims.makeAgents,
  server:    anims.makeServer,
  arch:      anims.makeArch,
  pixelrain: anims.makePixelRain,
};

// Single shared rAF loop drives all card animations instead of 11 independent loops.
// Each animation is only ticked when its canvas is in the viewport and the tab is visible.
const registeredTicks = [];
let loopStarted = false;

function sharedLoop() {
  requestAnimationFrame(sharedLoop);
  if (document.hidden) return;
  for (const entry of registeredTicks) {
    if (entry.inView) entry.tick();
  }
}

document.querySelectorAll('.pb-canvas').forEach(canvas => {
  const type = canvas.getAttribute('data-type');
  if (!MAKERS[type]) return;

  // Defer initialization until the canvas first scrolls into view.
  launchWhenVisible(canvas, () => {
    const tick = MAKERS[type](canvas);
    const entry = { tick, inView: true };

    // Continue tracking visibility so off-screen canvases skip their tick.
    new IntersectionObserver(
      ([e]) => { entry.inView = e.isIntersecting; },
      { threshold: 0 }
    ).observe(canvas);

    registeredTicks.push(entry);

    if (!loopStarted) {
      loopStarted = true;
      requestAnimationFrame(sharedLoop);
    }
  });
});
launchBgBokeh();
